module.exports = __webpack_public_path__ + "static/assets/a8d7a5acf0d573c4b5bfddfbdb4dc2f2.png";